// This file was auto-generated by Fern from our API Definition.
export const QueryEnvironmentVariantsRequestOrder = {
    Ascending: "ascending",
    Descending: "descending",
};
